import {Model} from '@vuex-orm/core';
import User from "$src/models/userModel";

export default class Application extends Model {

    static entity = 'application';
    static primaryKey = 'id_application';

    static fields() {
        return {
            id_application: this.attr(null),
            id_user: this.attr(null),
            status: this.attr(null),
            independence_agreement: this.attr(null),
            dsvgo_agreement: this.attr(null),
            has_agreement: this.attr(null),
            iona_tan: this.attr(null),
            iona_status: this.attr(null),
            iona_status_lft: this.attr(null),
            iona_status_pesa: this.attr(null),
            legal_age: this.attr(null),
            files: this.attr(null),
            progress: this.attr(null),
            user: this.belongsTo(User, 'id_user', 'id_user'),
            interview: this.attr(null),
            properties: this.attr(null),
            school_next_three_years: this.number(0),
        };
    }

    get schoolNextThreeYearsString() {
        return this.school_next_three_years ? 'Ja' : 'Nein';
    }

}